"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
// Vue components
const BuildingInfo_vue_1 = __importDefault(require("@becrop/components/Toolkit/Common/vue/BuildingInfo.vue"));
const CooccurrenceTool_vue_1 = __importDefault(require("@becrop/components/Toolkit/Cooccurrence/vue/CooccurrenceTool.vue"));
const ClusterEditor_vue_1 = __importDefault(require("@becrop/components/Toolkit/Common/vue/ClusterEditor.vue"));
const Zero_vue_1 = __importDefault(require("@becrop/components/Toolkit/Common/vue/Zero.vue"));
const Parcel_1 = __importDefault(require("@becrop/components/Toolkit/Common/models/Parcel"));
const Info_1 = __importDefault(require("@becrop/components/Toolkit/Common/models/Info"));
const Cooccurrence_1 = __importDefault(require("@becrop/components/Toolkit/Cooccurrence/models/Cooccurrence"));
const trans_1 = require("@common/tsutils/trans");
let CooccurrenceView = class CooccurrenceView extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.parcels = null;
        this.clusters = null;
        this.beforeClustersInfo = null;
        this.afterClustersInfo = null;
        this.cooccurrenceResult = null;
        this.stage = "loading1"; // loading1 -> clusters -> loading2 -> tool
    }
    created() {
        this.beforeClustersInfo = new Info_1.default({
            title: (0, trans_1.trans)('toolkit.clusters.fetching'),
            subtitle: (0, trans_1.trans)('toolkit.clusters.fetching__sub'),
            emphatizer: (0, trans_1.trans)('toolkit.clusters.fetching__emp'),
        });
        this.afterClustersInfo = new Info_1.default({
            title: (0, trans_1.trans)('toolkit.coocurrence.creating.title'),
            subtitle: (0, trans_1.trans)('toolkit.coocurrence.creating.subtitle'),
            emphatizer: (0, trans_1.trans)('toolkit.coocurrence.creating.emphatize'),
        });
    }
    mounted() {
        this.loadParcels();
    }
    setStage(newStage) {
        this.stage = newStage;
    }
    async loadParcels() {
        this.parcels = await Parcel_1.default.all();
        //await sleep(2300);
        if (this.parcels) {
            (this.parcels.length > 0) ? this.stage = 'clusters' : this.stage = 'zero';
        }
    }
    async onClusters(clusters) {
        this.stage = 'loading2';
        //await sleep(3000);
        this.clusters = clusters;
        const coocurrence = new Cooccurrence_1.default(clusters);
        this.cooccurrenceResult = await coocurrence.compare();
        this.stage = 'tool';
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], CooccurrenceView.prototype, "is_biome", void 0);
CooccurrenceView = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            BuildingInfo: BuildingInfo_vue_1.default,
            ClusterEditor: ClusterEditor_vue_1.default,
            CooccurrenceTool: CooccurrenceTool_vue_1.default,
            Zero: Zero_vue_1.default
        }
    })
], CooccurrenceView);
exports.default = CooccurrenceView;
